export const getArtworkSize = (width, height) => {
  const w = parseFloat(width) ? parseFloat(width) + `" W` : ``
  const h = parseFloat(height) ? parseFloat(height) + `" H` : ``
  return [h, w].filter(Boolean).join(` x `)
}
